import './SearchSelect.css';
import Select, { ActionMeta, PropsValue, SingleValue } from 'react-select';

interface SearchSelectProps {
   options: any;
   value:
      | PropsValue<{
           value: string;
           label: string;
        }>
      | undefined;
   onChange:
      | ((
           newValue: SingleValue<{
              value: string;
              label: string;
           }>,
           actionMeta: ActionMeta<{
              value: string;
              label: string;
           }>
        ) => void)
      | undefined;
   placeholder: string;
}

export function SearchSelect({ options, value, onChange, placeholder }: SearchSelectProps) {
   return (
      <Select
         options={options}
         placeholder={placeholder}
         onChange={onChange}
         value={value}
         noOptionsMessage={() => 'No results found'} // Customize "No results" message
         styles={{
            control: (baseStyles, state) => ({
               ...baseStyles,
               backgroundColor: 'var(--g-gray-background-2)', // Match input background color
               color: 'white',
               padding: '10px 8px',
               fontSize: '14px',
               borderRadius: '8px',
               boxShadow: state.isFocused ? '0 0 0 2px var(--g-primary)' : 'none',
               border: '1px solid var(--g-gray-pri)',
               '&:hover': {
                  backgroundColor: 'var(--g-gray-background-hover)',
               },
            }),
            singleValue: (baseStyles) => ({
               ...baseStyles,
               color: 'white', // Ensures selected value is white
            }),
            input: (baseStyles) => ({
               ...baseStyles,
               color: 'white', // Ensures typed text is visible
            }),
            menu: (baseStyles) => ({
               ...baseStyles,
               backgroundColor: 'rgb(60, 60, 60)', // Ensures menu background is the same as other inputs
               padding: 0,
            }),
            menuList: (baseStyles) => ({
               ...baseStyles,
               backgroundColor: 'rgb(60, 60, 60)', // Ensures consistency when empty
            }),
            noOptionsMessage: (baseStyles) => ({
               ...baseStyles,
               color: 'white', // Ensures "No results found" text is visible
               backgroundColor: 'rgb(60, 60, 60)',
               padding: '8px',
               borderRadius: '4px',
            }),
            option: (baseStyles, state) => ({
               ...baseStyles,
               backgroundColor: state.isSelected ? 'rgb(41, 41, 41)' : 'rgb(60, 60, 60)',
               color: state.isSelected ? 'white' : 'var(--g-text-color)',
               '&:hover': {
                  backgroundColor: 'rgb(41, 41, 41)',
                  color: 'white',
               },
            }),
            dropdownIndicator: (baseStyles) => ({
               ...baseStyles,
               color: 'white',
               '&:hover': {
                  color: 'var(--g-primary)',
               },
            }),
            indicatorSeparator: () => ({
               display: 'none', // Remove the separator line
            }),
         }}
      />
   );
}
